import { call, put, takeEvery } from "redux-saga/effects";
import {
    getClassification,
    addNewClassification,
    updateClassification,
    deleteClassification,
} from "../../api/backend_helper";
import {
    getDataAll,
    getDataAllFail,
    getDataAllSuccess,
    addClassification,
    addClassificationSuccess,
    addClassificationFail,
    updateClassification as updateClassificationAction,
    updateClassificationFail,
    updateClassificationSuccess,
    deleteClassification as deleteClassificationAction,
    deleteClassificationFail,
    deleteClassificationSuccess,
} from "./slice";

function* getClassificationData(action) {
    try {
        const query = action.payload;
        const data = yield call(getClassification, query);
        yield put(getDataAllSuccess(data));
    } catch (error) {
        yield put(getDataAllFail(error.message));
    }
}

function* createClassificationSaga(action) {
    try {
        const data = yield call(addNewClassification, action.payload.data);
        yield put(addClassificationSuccess(data));
    } catch (error) {
        yield put(addClassificationFail(error.message));
    }
}

function* modifyClassification(action) {
    try {
        const data = yield call(
            updateClassification,
            action.payload.data.id,
            action.payload.data
        );
        yield put(updateClassificationSuccess(data));
    } catch (error) {
        yield put(updateClassificationFail(error.message));
    }
}

function* removeClassification(action) {
    try {
        yield call(deleteClassification, action.payload.id);
        yield put(deleteClassificationSuccess(action.payload.id));
    } catch (error) {
        yield put(deleteClassificationFail(error.message));
    }
}

function* ClassificationsSaga() {
    yield takeEvery("classification/getDataAll", getClassificationData);
    yield takeEvery(addClassification.type, createClassificationSaga);
    yield takeEvery(updateClassificationAction.type, modifyClassification);
    yield takeEvery(deleteClassificationAction.type, removeClassification);
}

export default ClassificationsSaga;
